import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "48.529",
  height: "50",
  viewBox: "0 0 48.529 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M24.159 0c-3.467 0-6.618 2.205-6.303 6.512-6.092 2.521-10.19 8.51-10.19 15.338v12.814c0 3.466-2.834 6.198-6.195 6.198H0v2.94h48.527v-2.94h-1.576c-3.466 0-6.197-2.837-6.197-6.198V21.85c0-6.828-4.096-12.817-10.293-15.338C30.776 2.311 27.625 0 24.159 0zm0 2.942c1.785 0 3.36 1.47 3.36 3.36 0 1.366-.525 2.206-.525 2.206l1.366.316c5.673 1.786 9.454 7.037 9.454 12.92V36.03s-.106 2.1 2.415 4.726H8.302c2.494-2.086 2.306-4.726 2.306-4.726V21.85c0-5.883 3.781-11.136 9.453-12.922l1.471-.42s-.525-.84-.525-2.206a3.148 3.148 0 0 1 3.151-3.36zm-8.615 43.906V50h17.332v-3.15z"
  })]
});